<template>
	<v-form ref="form">
		<v-row class="mt-4">
			<v-col cols="4" class="py-0">
				<MesInput
					label="Período Inicial"
					v-model="value.mesInicial"
					:rules="regra.mesInicial"
					:change="periodoInicialChange"
					:min="mesAtual"
					:disabled="value.fnEditar"
					required
				></MesInput>
			</v-col>
			<v-col cols="4" class="py-0">
				<MesInput
					label="Período Final"
					v-model="value.mesFinal"
					:rules="regra.mesFinal"
					:change="periodoFinalChange"
					:min="mesAtual"
					:disabled="value.fnEditar"
					required
				></MesInput>
			</v-col>
			<v-col cols="4" class="py-0">
				<v-autocomplete
					label="Produto"
					outlined
					class="input-cinza"
					dense
					v-model="id_produtoBusca"
					:items="lista.produto"
					:search-input.sync="buscaProdutoFornecedor"
					:loading="isLoadingProduto"
					@change="produtoChange()"
					:disabled="value.fnEditar"
					:menu-props="menuProps"
					clearable
				>
					<template v-slot:no-data>
						<p
							v-if="
								!buscaProdutoFornecedor ||
								(buscaProdutoFornecedor &&
									buscaProdutoFornecedor.length <= 4)
							"
							class="ml-4 mt-4"
						>
							Insira pelo menos 4 caracteres para listar os
							produtos.
						</p>
						<p v-else-if="isLoadingProduto" class="ml-4 mt-4">
							Buscando produtos...
						</p>
						<p v-else class="ml-4 mt-4">Nada encontrado</p>
					</template>
				</v-autocomplete>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="4" class="py-0">
				<v-text-field
					label="Fornecedor"
					class="input-cinza"
					v-model="value.fornecedor"
					:rules="regra.fornecedor"
					:disabled="value.fnEditar"
					outlined
					dense
					readonly
					required
				></v-text-field>
			</v-col>
			<v-col cols="4" class="py-0">
				<v-select
					label="Bandeira"
					outlined
					dense
					class="input-cinza"
					v-model="value.bandeira"
					:items="lista.bandeira"
					:rules="regra.bandeira"
					:disabled="value.fnEditar && value.fnReplicar == false"
					:menu-props="menuProps"
					required
				></v-select>
			</v-col>
			<v-col cols="4" class="py-0">
				<v-text-field
					label="Tipo de Acordo"
					class="input-cinza"
					:value="'Padrão'"
					outlined
					dense
					:disabled="true"
					required
				></v-text-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="4" class="py-0">
				   <v-select
					   label="Campanha Circuito"
					   outlined
					   multiple
					   dense
					   class="input-cinza"
					   :items="lista.espaco"
					   :disabled="true"
					   v-model="value.id_espaco"
					   :menu-props="menuProps"
				   ></v-select>
			</v-col>
			<v-col cols="12" class="py-0">
				<v-textarea
					outlined
					v-model="value.obs_departamento"
					class="input-cinza"
					dense
					rows="3"
					label="Observação Departamento"
				></v-textarea>
				<v-textarea
					outlined
					v-model="value.obs_contrato"
					class="input-cinza"
					dense
					rows="3"
					label="Observação do Contrato"
				></v-textarea>
			</v-col>
		</v-row>
		<v-overlay
			:value="semAcesso"
			:absolute="true"
			:opacity="0.1"
			:z-index="3"
		></v-overlay>
	</v-form>
</template>
<script>
export default {
	inject: ['listaCampos'],
	props: ['value', 'usuarioTipo'],
	data() {
		return {
			   acordo: {
				   mesInicial: null,
				   mesFinal: null,
				   id_espaco: null,
				   id_fornecedor: null,
				   fornecedor: null,
				   bandeira: null,
				   tipo_acordo: 'Padrão',
				   obs_departamento: null,
				   obs_contrato: null,
				   comentario: null,
				   fnEditar: false,
				   fnLeitura: false,
				   espaco_macro: null,
				   valores: [],
			   },
			lista: {
				bandeira: [],
				espaco: [],
			},
			id_produtoBusca: null,
			buscaProdutoFornecedor: null,
			isLoadingProduto: false,
			regra: {
				mesInicial: [
					(v) => !!v || 'O campo período inicial é obrigatório',
					(v) =>
						(v && v >= this.mesAtual) ||
						this.value.fnLeitura ||
						'O período inicial deve ser igual ou posterior ao mês atual',
				],
				mesFinal: [
					(v) => !!v || 'O campo período final é obrigatório',
					(v) =>
						(v && v >= this.value.mesInicial) ||
						'O período final deve ser igual ou posterior ao período inicial',
				],
				fornecedor: [(v) => !!v || 'O campo fornecedor é obrigatório'],
				bandeira: [(v) => !!v || 'O campo bandeira é obrigatório'],
				modelo: [
					(v) =>
						!!v ||
						this.value.fnLeitura ||
						'O campo modelo check-out é obrigatório',
				],
				testeira: [
					(v) =>
						(this.value.metodo_criacao == 'MD' && !!v) ||
						'O campo testeira é obrigatório',
				],
				marca: [
					(v) =>
						(this.value.metodo_criacao == 'MD' && !!v) ||
						'O campo marca é obrigatório',
				],
				investimento_total: [
					(v) => !!v || 'O campo valor de investimento é obrigatório',
					(v) => {
						if (!v)
							return 'O campo valor de investimento é obrigatório'
						const valor = v
							.replace('R$ ', '')
							.replaceAll('.', '')
							.replace(',', '.')
						return (
							Number(valor) > 0 ||
							'O campo valor de investimento deve ser maior que 0'
						)
					},
				],
			},
			semAcesso: false,
			loadingMarcas: false,
			listaMarcas: [],
			menuProps: {
				bottom: true,
				offsetY: true,
				contentClass: 'select-outline',
				transition: 'slide-y-transition',
			},
		}
	},
	async created() {
		var lista = await this.listaCampos();
		console.log('RESPOSTA listaCampos:', lista);
		// Garante que a lista de bandeiras está no formato correto para o v-select
		if (Array.isArray(lista.bandeira)) {
			this.lista.bandeira = lista.bandeira.map(b => ({
				text: b.text,
				value: b.text
			}));
		} else {
			this.lista.bandeira = [];
		}
		// Garante que o campo id_espaco sempre recebe 'Campanha Circuito' se existir na lista
		if (Array.isArray(lista.espaco)) {
			const espacoCircuito = lista.espaco.find(e => (e.value || e) === 'Campanha Circuito');
			if (espacoCircuito) {
				this.value.id_espaco = espacoCircuito.value || espacoCircuito;
			} else if (lista.espaco.length > 0 && !this.value.id_espaco) {
				this.value.id_espaco = lista.espaco[0].value || lista.espaco[0];
			}
		}
	},
	computed: {
		mesAtual() {
			return this.$moment().format('YYYY-MM')
		},
	},
	watch: {
		async buscaProdutoFornecedor(val) {
			if (!val) {
				this.id_produtoBusca = null
				return
			}
			if (val.length < 4) return
			if (this.isLoadingProduto) return
			this.isLoadingProduto = true
			var data = {
				produto: val,
				negociacao_comercial: 'SIM',
			}
			var response = await this.$http().post('/acordo/buscaProdutos', {
				data: data,
			})
			this.lista.produto = response.data
			this.isLoadingProduto = false
		},
		id_produtoBusca(val) {
			var produto = this.lista.produto.find((e) => e.value == val)
			this.value.id_fornecedor = produto ? produto.id_fornecedor : null
			this.value.fornecedor = produto ? produto.fornecedor : null
		},
	},
	methods: {
		changed() {},
		toggle() {},
		setSemAcesso(semAcesso) {
			this.semAcesso = semAcesso
		},
		limpaCadastro() {
			this.resetValidation()
			this.id_produtoBusca = null
			this.buscaProdutoFornecedor = null
			this.fornecedor = null
			this.lista.produto = []
			this.acordo = {
				mesInicial: null,
				mesFinal: null,
				id_fornecedor: null,
				fornecedor: null,
				bandeira: null,
				obs_departamento: null,
				obs_contrato: null,
				comentario: null,
				fnEditar: false,
			}
		},
		limpaProdutos() {
			this.$emit('limpaProdutos')
		},
		validate() {
			return this.$refs.form.validate()
		},
		negociacaoChange() {
			this.limpaProdutos()
			this.limpaCadastro()
		},
		produtoChange() {
			this.limpaProdutos()
		},
		resetValidation() {
			try {
				this.$refs.form.resetValidation()
			} catch (error) {
				// erro ignorado propositalmente
			}
		},
		periodoInicialChange(valor) {
			if (this.value.mesFinal < valor) {
				this.value.mesFinal = valor
			}
		},
		periodoFinalChange(valor) {
			if (this.value.mesInicial > valor) {
				this.value.mesInicial = valor
			}
		},
	},
}
</script>